import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { parse, isValid } from 'date-fns';

import AccessControl from 'components/AccessControl';
import FormTypeSelect from 'components/Common/FormTypeSelect';
import ActivityPerms from 'components/AccessControl/permissions.json';
import {
  TextInput,
  SelectInput,
  CheckboxInput,
  preventInvalidDateInitialization,
  RenderDatePicker
} from 'components/Common/Inputs';
import RadioTableGroup from 'components/Common/Inputs/RadioTableGroup';
import AutoCompleteInput from 'components/Common/Inputs/AutoCompleteInput';
import HintButton from 'components/Common/Buttons/HintButton';
import FileUpload from 'components/Common/FileUpload';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import { takeQueueItem, getStorageSetting } from 'actions';

import { ApiService } from 'services';

const isRequired = value => !value || !value.trim();
const isEmailAddress = value => (value ? value.indexOf('@') === -1 : false);
const hasWhdStatement = (value, values) => (values.witholdingStmnt && (value === 'undefined' || value === null));

class AddFormsPopupForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    parentForm: PropTypes.shape(),
    addImyLayer: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    setDisableConfirm: PropTypes.func.isRequired,
    toggleCreateNewCustomerWForm: PropTypes.func.isRequired,
    toggleCreateNewCustomerCRSForm: PropTypes.func.isRequired,
    isCreateNewCustomerWFormChecked: PropTypes.bool.isRequired,
    isCreateNewCustomerCRSFormChecked: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    isSubmitting: PropTypes.bool,
    results: PropTypes.shape({
      customerIds: PropTypes.arrayOf(PropTypes.shape()),
      success: PropTypes.bool,
      error: PropTypes.shape({
        code: PropTypes.number,
        message: PropTypes.string,
      }),
      files: PropTypes.arrayOf(PropTypes.shape({}))
    }),
  }

  static defaultProps = {
    results: null,
    permissions: null,
    parentForm: null,
    addImyLayer: false,
    isSubmitting: false
  };

  static onFileUploadCancel(file) {
    toastr.info('', `Upload of ${ file.name } has been canceled`);
  }

  static onFileUploadError(file, error) {
    toastr.error('', `Upload of ${ file.name } has been canceled.  ${ error.message }`);
  }

  /* eslint-disable-no-unused-state */
  constructor(props) {
    super(props);

    const clients = this.filterClientList() || [];
    const files = getStorageSetting('files') || [];

    this.showCreateCustomer = true;
    const clientKey = (clients != null && clients.length === 1) ? clients[0].key : '';
    this.state = {
      files,
      addImyLayer: props.addImyLayer,
      clientId: clientKey,
      legalEntity: null,
      wFormReference: null,
      crsFormReference: null,
      customerType: null,
      usNonUs: null,
      customer: null,
      createCustomer: false,
      wFormDate: null,
      crsCustomer: null,
      crsFormDate: null,
      activeTab: 0,
      tabs: [
        { title: props.parentForm && props.addImyLayer ? 'IMY' : 'W Forms', index: 0, enabled: props.parentForm && props.addImyLayer, visible: props.addImyLayer },
        { title: 'CRS Forms', index: 1, enabled: false, visible: false },
        { title: props.parentForm ? 'Beneficiary Forms' : 'IMY', index: 2, enabled: props.parentForm && !props.addImyLayer, visible: !props.addImyLayer },
        { title: 'Supporting Docs', index: 3, enabled: false, visible: false },
        { title: 'Results', index: 4, enabled: false, visible: false }
      ],
      whdAgents: {
        uswa: false,
        qi: false,
        ffi: false
      },
      formType: null,
      crsFormType: null,
      benefFormType: null,
      whdStatementType: null,
      whdStatement: null,
      whdEffectiveDate: null,
      imyAccountNumber: null,
      newImyAccountNumber: '',
      supportingDocType: null,
      showBeneficiaryFileUpload: false,
      originEmail: null,
      clients,
      wForms: [],
      crsForms: [],
      benefForms: [],
      supportingDocs: [],
      formErrors: [],
      showAllForms: (props.parentForm == null),
      leChapter3Shown: false,
      leChapter4Shown: false
    };

    this.onFormTypeChange = this.onFormTypeChange.bind(this);

    props.dispatch(change('uploadingPdfForm', 'addImyLayer', props.addImyLayer));
    if (clientKey != null) {
      props.dispatch(change('uploadingPdfForm', 'clientId', `${ clientKey }`));
    }
  }

  componentDidUpdate(prevProps) {
    const { results, setDisableConfirm } = this.props;
    const { tabs } = this.state;
    if (prevProps.results !== results) {
      if (results != null && results.error != null) {
        setDisableConfirm(false);
        tabs[3].enabled = true;
      }
    }
  }

  onSelectTab(tabIndex) {
    const { isSubmitting } = this.props;
    const { tabs } = this.state;

    if (isSubmitting) {
      return;
    }

    if (tabs != null) {
      Object.keys(tabs).forEach((index) => {
        if (index != null) {
          tabs[index].visible = (tabs[index].index === tabIndex);
        }
      });
    }

    this.setState({
      activeTab: tabIndex,
      tabs
    });
  }

  /* File Uploads */

  onWFormFileUploadSuccess(file, response) {
    const { wForms } = this.state;
    const { setDisableConfirm } = this.props;
    const joined = wForms.concat(response);
    this.setState({ wForms: joined });
    setDisableConfirm(false);

    toastr.success('', `${ response[0].fileName } has been uploaded`);
  }

  onCrsFormFileUploadSuccess(file, response) {
    const { setDisableConfirm } = this.props;
    const { crsForms } = this.state;
    const joined = crsForms.concat(response);
    this.setState({ crsForms: joined });
    setDisableConfirm(false);

    toastr.success('', `${ response[0].fileName } has been uploaded`);
  }

  onBenefFormFileUploadSuccess(file, response) {
    const { setDisableConfirm, parentForm } = this.props;
    const { benefForms } = this.state;
    const joined = benefForms.concat(response);
    this.setState({ benefForms: joined });
    if (parentForm != null) {
      setDisableConfirm(false);
    }

    toastr.success('', `${ response[0].fileName } has been uploaded`);
  }

  onWhdStatementFileUploadSuccess(file, response) {
    this.setState({ whdStatement: response[0] });

    toastr.success('', `${ response[0].fileName } has been uploaded`);
  }

  onSupportingDocFileUploadSuccess(file, response) {
    const { supportingDocs } = this.state;
    const joined = supportingDocs.concat(response);
    this.setState({ supportingDocs: joined });
    toastr.success('', `${ response[0].fileName } has been uploaded`);
  }

  onDeleteWForm(file) {
    let { wForms } = this.state;
    const matched = wForms.filter(f => f.fileName === file.name);
    const { setDisableConfirm } = this.props;

    if (matched != null && matched.length > 0) {
      const fileId = matched[0].id;
      ApiService
        .deleteTempUpload(matched[0].id)
        .then((result) => {
          if (result != null) {
            wForms = wForms.filter(doc => doc.id !== fileId);

            this.setState({ wForms });
            setDisableConfirm(!wForms || wForms.length === 0);
          } else {
            toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
          }
        })
        .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
    }
  }

  onDeleteCrsForm(file) {
    let { crsForms } = this.state;
    const matched = crsForms.filter(f => f.fileName === file.name);

    if (matched != null && matched.length > 0) {
      const fileId = matched[0].id;
      ApiService
        .deleteTempUpload(matched[0].id)
        .then((result) => {
          if (result != null) {
            crsForms = crsForms.filter(doc => doc.id !== fileId);

            this.setState({ crsForms });
          } else {
            toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
          }
        })
        .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
    }
  }

  onDeleteBeneficiaryForm(file) {
    ApiService
      .deleteTempUpload(file.id)
      .then((result) => {
        if (result != null) {
          let { benefForms } = this.state;
          benefForms = benefForms.filter(doc => doc.id !== file.id);
          this.setState({ benefForms });
        } else {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      })
      .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
  }

  onDeleteWhdStatement(file) {
    ApiService
      .deleteTempUpload(file.id)
      .then((result) => {
        if (result != null) {
          this.setState({ whdStatement: null });
        } else {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      })
      .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
  }

  onDeleteSupportingDocument(file) {
    ApiService
      .deleteTempUpload(file.id)
      .then((result) => {
        if (result != null) {
          let { supportingDocs } = this.state;
          supportingDocs = supportingDocs.filter(doc => doc.id !== file.id);
          this.setState({ supportingDocs });
        } else {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      })
      .catch(err => toastr.error('', `Failed to remove ${ file.name }.  Please try again`));
  }

  /* Input Changes */

  onFormTypeChange(e, newValue) {
    const { tabs } = this.state;

    if (newValue === 'w8imy' || newValue === 'w8imy_2017') {
      const showAllocationStmts = getStorageSetting('showAllocationStmts') || false;
      tabs[2].enabled = showAllocationStmts;
    } else {
      tabs[2].enabled = false;
    }

    this.setState({
      formType: newValue,
      tabs
    });
  }

  /* Results Actions */

  onTakeForm(id) {
    const { dispatch } = this.props;

    if (!id) {
      toastr.error('Error', 'Cannot navigate to the form at this time.  Please return to \'Home\' and pick this up from the \'Initial Review\' queue');
      return;
    }

    dispatch(takeQueueItem('form', id));
  }

  /* Form Validation */

  onFormSubmit(event) {
    const {
      onSubmit,
      parentForm,
      setDisableConfirm,
      isCreateNewCustomerWFormChecked,
      toggleCreateNewCustomerWForm,
      isCreateNewCustomerCRSFormChecked,
      toggleCreateNewCustomerCRSForm
    } = this.props;
    const { tabs } = this.state;
    const errors = this.validate();

    tabs[4].enabled = true;
    this.setState({ tabs });

    this.onSelectTab(4);

    if (errors != null && errors.length === 0) {
      onSubmit(parentForm, this.state);
      setDisableConfirm(true);
      tabs[3].enabled = false;
      if (isCreateNewCustomerWFormChecked) {
        toggleCreateNewCustomerWForm();
      }
      if (isCreateNewCustomerCRSFormChecked) {
        toggleCreateNewCustomerCRSForm();
      }
    } else {
      event.preventDefault();
    }
  }

  setAgentType(uswa, ch3, ffi) {
    const { permissions, isCreateNewCustomerWFormChecked } = this.props;
    const { whdAgents, tabs } = this.state;

    whdAgents.uswa = uswa;
    whdAgents.qi = ch3;
    whdAgents.ffi = ffi;

    this.setState({ crsCustomer: isCreateNewCustomerWFormChecked ? { id: -9999, value: '' } : null, whdAgents });

    tabs[0].enabled = (whdAgents.ffi || whdAgents.uswa || whdAgents.qi);
    tabs[1].enabled = (whdAgents.ffi);
    tabs[3].enabled = ((whdAgents.uswa || whdAgents.qi || whdAgents.ffi)
      && AccessControl.hasPermission(permissions, [ActivityPerms.scannedSupDocs]));

    this.setState({
      tabs
    });

    this.onSelectTab(0);
  }

  onClientChange = (e, newValue) => {
    const { createCustomer } = this.state;
    this.setState({ clientId: parseInt(newValue, 10), legalEntity: null, customer: createCustomer ? { id: -9999, value: '' } : null, crsCustomer: null });
  }

  onLegalEntitySelectedItem = (lookupValue) => {
    const { dispatch } = this.props;
    const { createCustomer, whdAgents } = this.state;
    this.setState({
      legalEntity: lookupValue,
      customer: createCustomer ? { id: -9999, value: '' } : null,
      crsCustomer: null,
      leChapter3Shown: false,
      leChapter4Shown: false
    });

    if (lookupValue && whdAgents.ffi && !lookupValue.crsParticipating) {
      dispatch(change('uploadingPdfForm', 'crsFormType', null));
      this.setState({ crsFormType: null, crsForms: null });
    }

    const uswa = lookupValue != null && (lookupValue.chapter4Status !== 6 && lookupValue.chapter4Status !== 7);
    const qi = lookupValue != null && lookupValue.chapter3Status !== 25 && lookupValue.chapter3Status !== 10 && lookupValue.chapter3Status !== 8;
    const ffi = lookupValue != null && ((lookupValue.chapter4Status === 6 || lookupValue.chapter4Status === 7) || lookupValue.crsParticipating);

    dispatch(change('uploadingPdfForm', 'whdAgentTypeUswa', uswa));
    dispatch(change('uploadingPdfForm', 'whdAgentTypeQi', qi));
    dispatch(change('uploadingPdfForm', 'whdAgentTypeFfi', ffi));

    this.setAgentType(uswa, qi, ffi);
  }

  onLegalEntityChange = (e, newValue) => {
    const { createCustomer } = this.state;
    this.setState({ legalEntity: null, customer: createCustomer ? { id: -9999, value: '' } : null, crsCustomer: null });
  }

  onFormReferenceChange = (e) => {
    this.setState({ wFormReference: e.target.value });
  }

  onCrsFormReferenceChange = (e) => {
    this.setState({ crsFormReference: e.target.value });
  }

  onCustomerType = (e, newValue, prevValue) => {
    const { dispatch } = this.props;
    const { wForms, crsForms, formType, crsFormType } = this.state;
    const newFormType = wForms && wForms.length > 0 ? formType : '';
    const newCrsFormType = crsForms && crsForms.length > 0 ? crsFormType : '';
    dispatch(change('uploadingPdfForm', 'formType', null));
    dispatch(change('uploadingPdfForm', 'crsFormType', null));
    this.setState({ customerType: newValue, formType: newFormType, crsFormType: newCrsFormType, showAllForms: false });
  };

  onUsNonUsChange = (e, newValue, prevValue) => {
    const { dispatch } = this.props;
    const { wForms, crsForms, formType, crsFormType } = this.state;
    const newFormType = wForms && wForms.length > 0 ? formType : '';
    const newCrsFormType = crsForms && crsForms.length > 0 ? crsFormType : '';
    dispatch(change('uploadingPdfForm', 'formType', null));
    dispatch(change('uploadingPdfForm', 'crsFormType', null));
    this.setState({ usNonUs: newValue, formType: newFormType, crsFormType: newCrsFormType, showAllForms: false });
  }

  onCustomerSelectedItem = (lookupValue) => {
    this.showCreateCustomer = false;
    this.setState({ customer: lookupValue, imyAccountNumber: null });
  }

  onCustomerChange = (e, newValue) => {
    const { createCustomer, crsCustomer } = this.state;
    if (!newValue && !crsCustomer) {
      this.showCreateCustomer = true;
    }
    this.setState({ customer: createCustomer ? { id: -9999, value: '' } : null, imyAccountNumber: null });
  };

  onCreateCustomerChange = (e, newValue, prevValue) => {
    const { toggleCreateNewCustomerWForm } = this.props;
    const { tabs } = this.state;
    this.setState({ customer: newValue ? { id: -9999, value: '' } : null, imyAccountNumber: null, createCustomer: newValue });
    if (tabs != null && tabs[1] != null && tabs[1].enabled) {
      this.setState({ crsCustomer: newValue ? { id: -9999, value: '' } : null });
    }
    toggleCreateNewCustomerWForm();
  }

  onWFormDateChange = (e, newValue, prevValue) => this.setState({ wFormDate: newValue });

  onCrsCustomerSelectedItem = (lookupValue) => {
    this.showCreateCustomer = false;
    this.setState({ crsCustomer: lookupValue });
  };

  onCrsCustomerChange = (e, newValue) => {
    const { createCustomer, customer } = this.state;
    if (!newValue && !customer) {
      this.showCreateCustomer = true;
    }
    this.setState({ crsCustomer: createCustomer ? { id: -9999, value: '' } : null });
  };

  onCrsCreateCustomerChange = (e, newValue, prevValue) => {
    const { toggleCreateNewCustomerCRSForm } = this.props;
    this.setState({ customer: newValue ? { id: -9999, value: '' } : null, crsCustomer: newValue ? { id: -9999, value: '' } : null, imyAccountNumber: null, createCustomer: newValue });
    toggleCreateNewCustomerCRSForm();
  }

  onCrsFormTypeChange = (e, newValue) => this.setState({ crsFormType: newValue });

  onCrsFormDateChange = (e, newValue, prevValue) => this.setState({ crsFormDate: newValue });

  onWhdStatementTypeChange = (e, newValue) => this.setState({ whdStatementType: newValue, showBeneficiaryFileUpload: (newValue !== 'qipooled' && newValue !== 'nqipooled') });

  onWhdEffectiveDateChange = (e, newValue) => this.setState({ whdEffectiveDate: newValue });

  onImyAccountNumberSelectedItem = lookupValue => this.setState({ imyAccountNumber: lookupValue });

  onBeneficiaryFormTypeChange = (e, newValue) => this.setState({ benefFormType: newValue });

  onOriginEmailChange = (e, newValue) => this.setState({ originEmail: newValue.trim() });

  onSupportingDocTypeChange = (e, newValue) => this.setState({ supportingDocType: newValue });

  onImyCustomerSelectedItem = (lookupValue, index) => {
    const { benefForms } = this.state;
    benefForms[index].customer = lookupValue.id;
    this.setState({ benefForms });
  };

  onImyAccountNumberChange = (e, newValue) => {
    this.setState({ newImyAccountNumber: newValue });
  }

  onImyChoiceChange = (newValue) => {
    const { tabs } = this.state;

    tabs[2].enabled = !newValue;
    tabs[0].enabled = newValue;

    if (newValue) {
      tabs[0].title = 'IMY';
    } else {
      tabs[0].title = 'W Forms';
    }

    this.setState({ tabs, addImyLayer: newValue }, () => {
      this.onSelectTab(newValue ? 0 : 2);
    });
  }

  // eslint-disable-next-line react/sort-comp
  filterClientList = () => {
    const clients = getStorageSetting('clients') || [];
    const selectedClient = getStorageSetting('selectedClient');
    let filteredClientList = clients;

    if (selectedClient != null) {
      filteredClientList = [];
      filteredClientList.push(selectedClient);
    }

    return filteredClientList;
  }

  fieldHasErrors(field) {
    const { formErrors } = this.state;

    return formErrors != null && formErrors.filter(error => error.field === field).length > 0;
  }

  validate() {
    const { parentForm, isCreateNewCustomerCRSFormChecked } = this.props;
    const { clientId, legalEntity, whdAgents,
      customer, formType, wForms,
      crsCustomer, crsFormType, crsForms,
      wFormDate, crsFormDate,
      whdStatementType, whdStatement,
      originEmail, benefForms, addImyLayer,
      wFormReference, crsFormReference } = this.state;
    let { formErrors } = this.state;

    formErrors = [];
    if (!parentForm) {
      if (!clientId) {
        formErrors.push({ field: 'client', message: 'A Client is required' });
      }

      if (!legalEntity) {
        formErrors.push({ field: 'legalEntity', message: 'A Legal Entity is required' });
      }

      if (!whdAgents.uswa && !whdAgents.qi && !whdAgents.ffi) {
        formErrors.push({ field: 'whdAgents', message: 'A WHD Agent is required' });
      }
    }

    if (parentForm && !addImyLayer && (!benefForms || benefForms.length === 0)) {
      formErrors.push({ field: 'benefForms', message: 'At least one beneficiary form should be uploaded' });
    } else if (!parentForm || (parentForm && addImyLayer)) {
      if (!(wForms && wForms.length > 0)
        && !(crsForms && crsForms.length > 0)) {
        formErrors.push({ field: 'wFormCrsForm', message: 'At least one form should be uploaded' });
      } else {
        if ((parentForm || (formType && (whdAgents.uswa || whdAgents.qi))) && (customer || formType || (wForms && wForms.length > 0))) {
          if (!customer) {
            formErrors.push({ field: 'customer', message: `Please select the appropriate Customer ID${ (parentForm && addImyLayer) ? '' : ' or create a new Customer ID' }.` });
          }

          if (!formType) {
            formErrors.push({ field: 'formType', message: 'A W Form Type is required' });
          }

          if (!wForms == null || wForms.length === 0) {
            formErrors.push({ field: 'wForm', message: 'A W Form must be uploaded' });
          }
        }

        if (!parentForm && ((crsCustomer && (isCreateNewCustomerCRSFormChecked || crsCustomer.id > 0)) || crsFormType || (crsForms && crsForms.length > 0))) {
          if (!crsCustomer) {
            formErrors.push({ field: 'crsCustomer', message: 'Please select the appropriate Customer ID or create a new Customer ID.' });
          }

          if (!crsFormType) {
            formErrors.push({ field: 'crsFormType', message: 'A CRS Form Type is required' });
          }

          if (!crsForms == null || crsForms.length === 0) {
            formErrors.push({ field: 'crsForms', message: 'A CRS Form must be uploaded' });
          }
        }
      }

      if (formType != null && formType.indexOf('imy') !== -1) {
        if (!parentForm && whdStatementType && !whdStatement) {
          formErrors.push({ field: 'whdStatement', message: 'An Withholding statement must be uploaded' });
        } else if (!parentForm && !whdStatementType && whdStatement) {
          formErrors.push({ field: 'whdStatementType', message: 'A Withholding statement type is required' });
        }
      }

      if (wFormDate) {
        const parsedDate = parse(wFormDate, 'MMM dd, yyyy', new Date());
        if (!isValid(parsedDate)) {
          formErrors.push({ field: 'wFormDate', message: 'Invalid Signature Date on W Forms Tab' });
        }
      }

      if (crsFormDate) {
        const parsedDate = parse(crsFormDate, 'MMM dd, yyyy', new Date());
        if (!isValid(parsedDate)) {
          formErrors.push({ field: 'crsFormDate', message: 'Invalid Signature Date on CRS Forms Tab' });
        }
      }

      if (originEmail && originEmail.indexOf('@') === -1) {
        formErrors.push({ field: 'originEmail', message: 'The origin email entered is not a valid email address' });
      }

      if (wFormReference != null && wFormReference.length > 150) {
        formErrors.push({ field: 'form-reference', message: 'The w-form reference supplied is longer than 150 characters' });
      }

      if (wFormReference != null && wFormReference.match(/[^A-Za-z\d_/.\\-]/)) {
        formErrors.push({ field: 'form-reference', message: 'No spaces or special characters allowed in the w-form reference' });
      }

      if (crsFormReference != null && crsFormReference.length > 150) {
        formErrors.push({ field: 'crs-form-reference', message: 'The crs-form reference supplied is longer than 150 characters' });
      }

      if (crsFormReference != null && crsFormReference.match(/[^A-Za-z\d_/.\\-]/)) {
        formErrors.push({ field: 'crs-form-reference', message: 'No spaces or special characters allowed in the crs-form reference' });
      }
    }

    this.setState({
      formErrors
    });

    return formErrors;
  }

  render() {
    const {
      id,
      parentForm,
      isSubmitting,
      results,
      isCreateNewCustomerWFormChecked,
      isCreateNewCustomerCRSFormChecked
    } = this.props;
    const {
      files,
      formErrors,
      addImyLayer,
      clients,
      clientId,
      legalEntity,
      customerType,
      usNonUs,
      customer,
      crsCustomer,
      benefFormType,
      crsFormType,
      formType,
      whdStatement,
      whdStatementType,
      imyAccountNumber,
      activeTab,
      tabs,
      date,
      showBeneficiaryFileUpload,
      benefForms,
      supportingDocType,
      supportingDocs,
      showAllForms,
      leChapter3Shown,
      leChapter4Shown
    } = this.state;

    const individual = customerType === 'individual';
    const entity = customerType === 'entity';
    const usPerson = usNonUs === 'us';
    const usNonUsGiven = usNonUs != null;

    return (
      <div className="add-form-container">
        <form
          id={ id }
          onSubmit={ values => this.onFormSubmit(values) }
          className="form-horizontal"
          noValidate
        >
          { !parentForm && <div id="add-form-head" className="add-form-head">
            <div className="form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="client" className="form-label text-right">Client *</label>
              </div>
              <div className="col-8 col-sm-12">
                <Field
                  id="client"
                  name="clientId"
                  component={ SelectInput }
                  className={ `form-select ${ this.fieldHasErrors('client') ? 'is-error' : '' }` }
                  required
                  hideHints
                  value={ clientId }
                  validate={ isRequired }
                  onChange={ (e, newValue) => this.onClientChange(e, newValue) }
                  disabled={ clients.length === 1 }
                >
                  { clients != null && clients.length > 1 ? <option value="" disabled>Choose a client</option> : null }
                  { clients != null && clients.map(client => client != null && <option key={ client.key } value={ client.key }>{ client.value }</option>) }
                </Field>
              </div>
            </div>
            <div className="form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="legal-entity" className="form-label text-right">Legal Entity *</label>
              </div>
              <div className="col-8 col-sm-12">
                <AutoCompleteInput
                  id="legal-entity-id"
                  name="legalEntity"
                  category="legalentity"
                  context={ clientId != null ? { type: 'client', id: parseInt(clientId, 10), value: '' } : null }
                  placeholder="Enter legal entity name..."
                  className={ this.fieldHasErrors('legalEntity') ? 'is-error' : '' }
                  value={ legalEntity || '' }
                  onSelectedItem={ lookupValue => this.onLegalEntitySelectedItem(lookupValue) }
                  onChange={ (e, newVal) => this.onLegalEntityChange(e, newVal) }
                />
              </div>
            </div>

            { legalEntity != null && <div className="form-group">
              <div className="col-4 col-sm-12" />
              <div className="col-8 col-sm-12 le-property-labels">
                { legalEntity != null && <span>
                  { `Chapter 4: ${ legalEntity.chapter4Status != null ? legalEntity.chapter4Status.toString().padStart(2, '0') : 'NA' }` }
                  <HintButton hintType="hint" active={ leChapter4Shown } onClick={ () => { this.setState({ leChapter4Shown: !leChapter4Shown }); } } />
                  { `Chapter 3:  ${ legalEntity.chapter3Status != null ? legalEntity.chapter3Status.toString().padStart(2, '0') : 'NA' }` }
                  <HintButton hintType="hint" active={ leChapter3Shown } onClick={ () => { this.setState({ leChapter3Shown: !leChapter3Shown }); } } />
                  { `CRS: ${ legalEntity.crsParticipating ? 'Participating' : 'Non-Participating' }` }
                </span> }
                <div className={ `le-property-desc ${ leChapter3Shown || leChapter4Shown ? '' : 'hide' }` }>
                  { leChapter4Shown && <span>{ `Chapter 4: ${ legalEntity.chapter4Status.toString().padStart(2, '0') } - ${ legalEntity.chapter4StatusDescription }` }</span> }
                  { leChapter3Shown && <span>{ `Chapter 3: ${ legalEntity.chapter3Status.toString().padStart(2, '0') } - ${ legalEntity.chapter3StatusDescription }` }</span> }
                </div>
              </div>
            </div> }
            <br />
            <div className="form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="customer-type" className="form-label text-right">Customer Type&nbsp;&nbsp;</label>
              </div>
              <div className="col-8 col-sm-12">
                <RadioTableGroup
                  name="customerType"
                  items={ [[{ text: 'Individual', value: 'individual' }, { text: 'Entity', value: 'entity' }]] }
                  preventReset
                  onChange={ (e, newVal, prevVal) => this.onCustomerType(e, newVal, prevVal) }
                  className={ this.fieldHasErrors('customerType') ? 'is-error' : '' }
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="us-non-us" className="form-label text-right">Customer US / Non-US Status&nbsp;&nbsp;</label>
              </div>
              <div className="col-8 col-sm-12">
                <RadioTableGroup
                  name="usNonUsPerson"
                  items={ [[{ text: 'US Person', value: 'us' }, { text: 'Non-US Person', value: 'nonUs' }]] }
                  preventReset
                  onChange={ (e, newVal, prevVal) => this.onUsNonUsChange(e, newVal, prevVal) }
                  className={ this.fieldHasErrors('usNonUs') ? 'is-error' : '' }
                />
              </div>
            </div>
          </div> }
          { parentForm && <div id="add-form-head" className="add-form-head">
            <div className="form-group">
              <div className="col-4 col-sm-12">
                <label htmlFor="addImyLayer" className="form-label">Are you adding an IMY form to this layer?</label>
              </div>
              <div className="col-8 col-sm-12">
                <Field
                  id="add-imy-to-layer"
                  name="addImyLayer"
                  component={ CheckboxInput }
                  iValue="true"
                  item="Yes"
                  value={ addImyLayer.toString() }
                  onChange={ (event, newVal, prevVal) => this.onImyChoiceChange(newVal) }
                />
              </div>
            </div>
          </div> }
          <div id="add-form-body" className="add-form-body">
            <div className="add-form-tabs">
              <ul className="tab">
                { tabs != null && tabs.filter(t => t.enabled).map(tab => tab != null && (
                  <li
                    key={ tab.index }
                    className={ `tab-item ${ tab.enabled && tab.visible && tab.index === activeTab ? 'active' : '' }` }
                  >
                    <button
                      type="button"
                      tabIndex={ tab.index }
                      onClick={ () => this.onSelectTab(tab.index) }
                    >{ tab.title }</button>
                  </li>
                )) }
              </ul>
            </div>
            <div className="tab-body">
              { tabs != null && tabs[0] != null && tabs[0].enabled && <div id="tab-w-forms" className={ `${ tabs[0].enabled && tabs[0].visible ? 'active' : '' }` }>
                <div className="form-group">
                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="customer-id" className="form-label">Customer ID { !parentForm && <span>*</span> }</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <AutoCompleteInput
                          id="customer-id"
                          name="customerId"
                          category="customer"
                          context={ legalEntity }
                          placeholder="Enter Customer ID..."
                          className={ this.fieldHasErrors('customer') ? 'is-error' : '' }
                          required
                          value={ customer || '' }
                          onSelectedItem={ lookupValue => this.onCustomerSelectedItem(lookupValue) }
                          onChange={ (e, newVal) => this.onCustomerChange(e, newVal) }
                          disabled={ isCreateNewCustomerCRSFormChecked || isCreateNewCustomerWFormChecked }
                        />
                        { this.showCreateCustomer && !isCreateNewCustomerCRSFormChecked && <Field
                          id="create-customer"
                          name="createCustomer"
                          component={ CheckboxInput }
                          iValue="true"
                          item="Create New Customer ID"
                          className={ this.fieldHasErrors('customer') ? 'is-error' : '' }
                          onChange={ (e, newVal, prevVal) => { this.onCreateCustomerChange(e, newVal); } }
                        /> }
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="signature-date" className="form-label">Signature Date</label>
                      </div>
                      <div className="full-width-datepicker col-8 col-sm-12">
                        <Field
                          id="signature-date"
                          name="signatureDate"
                          component={ RenderDatePicker }
                          { ... { popperPlacement: 'right-end' } }
                          className={ `form-input ${ this.fieldHasErrors('wFormDate') ? 'is-error' : '' }` }
                          placeholder="MMM DD, YYYY"
                          required
                          onBlur={ preventInvalidDateInitialization }
                          onChange={ (e, newVal, prevVal) => { this.onWFormDateChange(e, newVal); } }
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="form-reference" className="form-label">Form Reference</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <input
                          id="form-reference"
                          name="form-reference"
                          className={ `form-input ${ this.fieldHasErrors('form-reference') ? 'is-error' : '' }` }
                          type="text"
                          placeholder="Enter reference..."
                          onChange={ e => this.onFormReferenceChange(e) }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="w-form-type" className="form-label">Form Type *</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <FormTypeSelect
                          id="pdf-form-type"
                          name="formType"
                          component={ SelectInput }
                          className={ `form-select ${ this.fieldHasErrors('formType') ? 'is-error' : '' }` }
                          required
                          validate={ isRequired }
                          value={ formType }
                          showAllForms={ showAllForms }
                          individual={ individual }
                          entity={ entity }
                          addImyLayer={ addImyLayer }
                          usNonUsGiven={ usNonUsGiven }
                          usPerson={ usPerson }
                          onChange={ this.onFormTypeChange }
                          showWFormTypes
                        />
                      </div>
                    </div>
                    <div className={ `form-group ${ formType === null || formType === '' ? 'none' : '' }` }>
                      <div className="col-12 col-sm-12">
                        <FileUpload
                          defaultMessage="Drop files here to upload in pdf format"
                          postUrl={ ApiService.getFileUploadUrl() }
                          accessTokenName={ ApiService.getAccessTokenName() }
                          acceptedFiles="application/pdf"
                          maxFilesize={ files.maxFilesize }
                          timeout={ files.uploadTimeout }
                          docCategory="form"
                          docType={ formType != null ? formType : '' }
                          onFileUploadCancel={ file => AddFormsPopupForm.onFileUploadCancel(file) }
                          onFileUploadSuccess={ (file, response) => this.onWFormFileUploadSuccess(file, response) }
                          onFileUploadError={ (file, error) => AddFormsPopupForm.onFileUploadError(file, error) }
                          onFileRemoved={ file => this.onDeleteWForm(file) }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> }
              { tabs != null && tabs[1] != null && tabs[1].enabled && <div id="tab-crs-forms" className={ `${ tabs[1].enabled && tabs[1].visible ? 'active' : '' }` }>
                <div className="form-group">
                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="customer-id" className="form-label">Customer ID *</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <AutoCompleteInput
                          id="crs-customer-id"
                          name="crsCustomerId"
                          category="customer"
                          context={ legalEntity }
                          placeholder="Enter Customer ID..."
                          className={ this.fieldHasErrors('crsCustomer') ? 'is-error' : '' }
                          required={ tabs[1].enabled }
                          value={ crsCustomer || '' }
                          onSelectedItem={ lookupValue => this.onCrsCustomerSelectedItem(lookupValue) }
                          onChange={ (e, newVal) => this.onCrsCustomerChange(e, newVal) }
                          disabled={ isCreateNewCustomerCRSFormChecked || isCreateNewCustomerWFormChecked }
                        />
                        { this.showCreateCustomer && !isCreateNewCustomerWFormChecked && !parentForm && <Field
                          id="create-crs-customer"
                          name="createCrsCustomer"
                          component={ CheckboxInput }
                          iValue="true"
                          item="Create New Customer ID"
                          className={ this.fieldHasErrors('crsCustomer') ? 'is-error' : '' }
                          onChange={ (e, newVal, prevVal) => { this.onCrsCreateCustomerChange(e, newVal); } }
                        /> }
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="crs-signature-date" className="form-label">Signature Date</label>
                      </div>
                      <div className="full-width-datepicker col-8 col-sm-12">
                        <Field
                          id="crs-signature-date"
                          name="crsSignatureDate"
                          component={ RenderDatePicker }
                          { ... { popperPlacement: 'right-end' } }
                          className={ `form-input ${ this.fieldHasErrors('crsFormDate') ? 'is-error' : '' }` }
                          placeholder="MMM DD, YYYY"
                          required={ tabs[1].enabled }
                          onBlur={ preventInvalidDateInitialization }
                          onChange={ (e, newVal, prevVal) => { this.onCrsFormDateChange(e, newVal); } }
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="crs-form-reference" className="form-label">Form Reference</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <input
                          id="crs-form-reference"
                          name="crs-form-reference"
                          className={ `form-input ${ this.fieldHasErrors('crs-form-reference') ? 'is-error' : '' }` }
                          type="text"
                          placeholder="Enter reference..."
                          onChange={ e => this.onCrsFormReferenceChange(e) }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="crs-form-type" className="form-label">Form Type *</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <FormTypeSelect
                          id="crs-form-type"
                          name="crsFormType"
                          component={ SelectInput }
                          className={ `form-select ${ this.fieldHasErrors('crsFormType') ? 'is-error' : '' }` }
                          required={ tabs[1].enabled }
                          validate={ isRequired }
                          value={ crsFormType }
                          showAllForms={ showAllForms }
                          individual={ individual }
                          entity={ entity }
                          onChange={ this.onCrsFormTypeChange }
                          showCrsFormTypes
                        />
                      </div>
                    </div>
                    { (crsFormType === 'ucrse_2019' || crsFormType === 'ucrscp_2019') && <div className="form-group">
                      <div className="col-12 col-sm-12">
                        <p><i>Text reading of uploaded Universal CRS forms is not supported. Once submitted, you can refer to the uploaded form to create a digital form for validation.</i></p>
                      </div>
                    </div> }
                    <div className={ `form-group ${ crsFormType === null || crsFormType === '' ? 'none' : '' }` }>
                      <div className="col-12 col-sm-12">
                        <FileUpload
                          defaultMessage="Drop files here to upload in pdf format"
                          postUrl={ ApiService.getFileUploadUrl() }
                          accessTokenName={ ApiService.getAccessTokenName() }
                          acceptedFiles="application/pdf"
                          maxFilesize={ files.maxFilesize }
                          timeout={ files.uploadTimeout }
                          docCategory="form"
                          docType={ crsFormType != null ? crsFormType : '' }
                          onFileUploadCancel={ file => AddFormsPopupForm.onFileUploadCancel(file) }
                          onFileUploadSuccess={ (file, response) => this.onCrsFormFileUploadSuccess(file, response) }
                          onFileUploadError={ (file, error) => AddFormsPopupForm.onFileUploadError(file, error) }
                          onFileRemoved={ file => this.onDeleteCrsForm(file) }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div> }
              { tabs != null && tabs[2] != null && tabs[2].enabled && <div id="tab-imy" className={ `${ tabs[2].enabled && tabs[2].visible ? 'active' : '' }` }>
                <div className="form-group">
                  <div className="col-6">
                    { !parentForm && <div className="form-group">
                      <div className="col-4 col-sm-12" style={ { paddingRight: '.5rem' } }>
                        <label htmlFor="whd-statement-type" className="form-label">WHD Stmt Type</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <Field
                          id="whd-statement-type"
                          name="statementType"
                          component={ SelectInput }
                          className={ `form-select ${ this.fieldHasErrors('whdStmtType') ? 'is-error' : '' }` }
                          validate={ hasWhdStatement }
                          onChange={ (e, newValue) => this.onWhdStatementTypeChange(e, newValue) }
                        >
                          <option value="" disabled>Choose a statement type</option>
                          <option value="nqipayeespecificfixed">NQI - Payee Specific - Fixed</option>
                          <option value="nqipayeespecificvariable">NQI - Payee Specific - Variable</option>
                          <option value="qipayeespecificvariable">QI - Payee Specific - Variable</option>
                          <option value="qipooled">QI - Pooled</option>
                          <option value="nqipooled">NQI - Pooled</option>
                        </Field>
                      </div>
                    </div> }
                    { !parentForm && whdStatementType != null && <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="pdf-form-file" className="form-label">WHD Stmt</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        { whdStatement == null && <FileUpload
                          defaultMessage="Drop the WHD Statement here to upload in TAINA's standard format"
                          postUrl={ ApiService.getFileUploadUrl() }
                          accessTokenName={ ApiService.getAccessTokenName() }
                          acceptedFiles="application/vnd.ms-excel, .xls, .xlsx"
                          maxFilesize={ 5 }
                          maxUploadFiles={ 1 }
                          timeout={ 60000 }
                          docCategory="withholdingstatement"
                          docType={ whdStatementType != null ? whdStatementType : '' }
                          removeFileAfterUpload
                          onFileUploadCancel={ file => AddFormsPopupForm.onFileUploadCancel(file) }
                          onFileUploadSuccess={ (file, response) => this.onWhdStatementFileUploadSuccess(file, response) }
                          onFileUploadError={ (file, error) => AddFormsPopupForm.onFileUploadError(file, error) }
                        /> }
                        { whdStatement != null && <div>
                          <span className="whd-file-name ellipsis">{ whdStatement.fileName }</span>
                          <button
                            className="btn btn-sm btn-danger text-right"
                            type="button"
                            title="Delete WHD statement"
                            onClick={ () => this.onDeleteWhdStatement(whdStatement) }
                          >
                            <span className="icon icon-delete" />
                          </button>
                        </div> }
                      </div>
                    </div> }
                    { !parentForm && whdStatementType != null && <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="effective-date-of-statement" className="form-label">Effective Date</label>
                      </div>
                      <div className="full-width-datepicker col-8 col-sm-12">
                        <Field
                          id="effective-date-of-statement"
                          name="effectiveStatementDate"
                          component={ RenderDatePicker }
                          { ... { popperPlacement: 'right-end' } }
                          className="form-input"
                          placeholder="MMM DD, YYYY"
                          autoComplete="off"
                          required={ false }
                          onBlur={ preventInvalidDateInitialization }
                          onChange={ (e, newValue) => this.onWhdEffectiveDateChange(e, newValue) }
                        />
                      </div>
                    </div> }
                    { !parentForm && whdStatementType != null && <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="imy-account-number" className="form-label">Account Number</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <AutoCompleteInput
                          id="imy-account-number"
                          name="imyAccountNumber"
                          category="account"
                          context={ customer && customer.id !== -9999 ? customer : null }
                          placeholder="Enter account..."
                          className={ this.fieldHasErrors('imyAccountNumber') ? 'is-error' : '' }
                          required={ tabs[1].enabled }
                          value={ imyAccountNumber || '' }
                          onSelectedItem={ lookupValue => this.onImyAccountNumberSelectedItem(lookupValue) }
                          onChange={ (e, newValue) => this.onImyAccountNumberChange(e, newValue) }
                        />
                      </div>
                    </div> }
                    { (parentForm || showBeneficiaryFileUpload) && <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="benef-form-type" className="form-label">Form Type</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <FormTypeSelect
                          id="benef-form-type"
                          name="benefFormType"
                          component={ SelectInput }
                          className="form-select"
                          value={ benefFormType }
                          beneficiaryForms
                          onChange={ this.onBeneficiaryFormTypeChange }
                        />
                      </div>
                    </div> }
                    { (parentForm || showBeneficiaryFileUpload) && <div className="form-group">
                      <div className="col-12 col-sm-12">
                        <FileUpload
                          defaultMessage="Drop Beneficiary(ies) Forms here to upload in .pdf format"
                          postUrl={ ApiService.getFileUploadUrl() }
                          accessTokenName={ ApiService.getAccessTokenName() }
                          acceptedFiles="application/pdf"
                          maxFilesize={ files.maxFilesize }
                          timeout={ files.uploadTimeout }
                          docCategory="form"
                          docType={ benefFormType != null ? benefFormType : '' }
                          removeFileAfterUpload
                          onFileUploadCancel={ file => AddFormsPopupForm.onFileUploadCancel(file) }
                          onFileUploadSuccess={ (file, response) => this.onBenefFormFileUploadSuccess(file, response) }
                          onFileUploadError={ (file, error) => AddFormsPopupForm.onFileUploadError(file, error) }
                        />
                      </div>
                    </div> }
                  </div>
                  <div className="col-6">
                    { (parentForm || showBeneficiaryFileUpload) && <div className="form-group">
                      <div className="col-12">
                        <table className="table table-striped table-hover table-data-side-bordered table-left-align">
                          <thead>
                            <tr>
                              <th>BO Forms</th>
                              <th colSpan="2">Customer ID</th>
                            </tr>
                          </thead>
                          <tbody>
                            { benefForms != null && benefForms.map((doc, index) => doc != null && <tr key={ doc.id }>
                              <td>{ `${ doc.fileName }` }</td>
                              <td>
                                <AutoCompleteInput
                                  id={ `imy-customer-id-${ index }` }
                                  name={ `imyCustomerId-${ index }` }
                                  category="customer"
                                  context={ legalEntity }
                                  placeholder="Enter Customer ID..."
                                  className={ this.fieldHasErrors(`imyCustomerId-${ index }`) ? 'is-error' : '' }
                                  required={ tabs[1].enabled }
                                  onSelectedItem={ lookupValue => this.onImyCustomerSelectedItem(lookupValue, index) }
                                />
                              </td>
                              <td>
                                <button
                                  className="btn btn-sm btn-danger"
                                  type="button"
                                  title="Delete document"
                                  onClick={ () => this.onDeleteBeneficiaryForm(doc) }
                                >
                                  <span className="icon icon-delete" />
                                </button>
                              </td>
                            </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>}
                  </div>
                </div>
              </div> }
              { tabs != null && tabs[3] != null && tabs[3].enabled && <div id="tab-supporting-docs" className={ `${ tabs[3].enabled && tabs[3].visible ? 'active' : '' }` }>
                <div className="form-group mb">
                  <div className="col-2 col-sm-12">
                    <label htmlFor="source-email-address" className="form-label form-label-padding">Source Email</label>
                  </div>
                  <div style={ { marginLeft: '-2px' } } className="col-10 col-sm-12">
                    <Field
                      id="source-email-address"
                      name="sourceEmailAddress"
                      component={ TextInput }
                      className={ `form-input ${ this.fieldHasErrors('whdStmtType') ? 'is-error' : '' }` }
                      placeholder="Enter source email address"
                      type="email"
                      selected={ date }
                      hideHints
                      normalize={ value => value && value.trim() }
                      validate={ isEmailAddress }
                      onChange={ (e, newValue) => this.onOriginEmailChange(e, newValue) }
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-4 col-sm-12">
                        <label htmlFor="supporting-doc-type" className="form-label">Document Type</label>
                      </div>
                      <div className="col-8 col-sm-12">
                        <Field
                          id="supporting-doc-type"
                          name="supportingDocType"
                          component={ SelectInput }
                          className="form-select"
                          hideHints
                          value={ supportingDocType }
                          onChange={ (e, newValue) => this.onSupportingDocTypeChange(e, newValue) }
                        >
                          <option value="" disabled>Choose a document type</option>
                          <option value="affidavitstatingnotprivatefoundation">Affidavit Stating Not Private Foundation</option>
                          <option value="armedforcesidcard">Armed Forces ID Card</option>
                          <option value="articleassoc">Articles of Association</option>
                          <option value="articleincorp">Articles of Incorporation</option>
                          <option value="auditorsletter">Auditor&apos;s Letter</option>
                          <option value="bankidcard">Bank ID Card</option>
                          <option value="cedula">Cedula</option>
                          <option value="certincorp">Certificate of Incorporation</option>
                          <option value="certltdpartner">Certificate of Limited Partnership</option>
                          <option value="certlossnationality">Certificate of Loss of Nationality</option>
                          <option value="certpartnership">Certificate of Partnership</option>
                          <option value="certreg">Certificate of Registration</option>
                          <option value="certofresidence">Certificate of Residence</option>
                          <option value="controllingpersonselfcertification">Controlling Person Self-Certification</option>
                          <option value="dateofbirthsupportingdoc">Date of Birth Supporting Doc</option>
                          <option value="drivinglicence">Driver’s License</option>
                          <option value="form8832">Form 8832</option>
                          <option value="irsdeterminationletter">IRS Determination Letter</option>
                          <option value="liquidationandbankruptcy">Liquidation and Bankruptcy</option>
                          <option value="memorandum">Memorandum of Association</option>
                          <option value="nationalidcard">National ID Card</option>
                          <option value="opinionfromuscounsel">Opinion From U.S. Counsel</option>
                          <option value="othergovid">Other Government ID</option>
                          <option value="ownerreportingstatement">Owner Reporting Statement</option>
                          <option value="partnership">Partnership Agreement</option>
                          <option value="passport">Passport</option>
                          <option value="permitofresidence">Permit of Residence</option>
                          <option value="powerofattorney">Power Of Attorney</option>
                          <option value="qdddocumentation">QDD Documentation</option>
                          <option value="qslstatement">QSL Statement</option>
                          <option value="writtenexplanation">Reasonable Written Explanation</option>
                          <option value="regcert">Registration Certificate</option>
                          <option value="taxpayercert">Taxpayer Certificate</option>
                          <option value="tinnotissued">Tin Not Issued</option>
                          <option value="trustagreement">Trust Agreement</option>
                          <option value="trustdeed">Trust Deed</option>
                          <option value="trusteedocumentedtrustletter">Trustee Documented Trust Letter</option>
                          <option value="votercard">Voter Registration Card</option>
                          <option value="will">Will</option>
                          <option value="notlisted">Other document type not listed above</option>
                        </Field>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-12 col-sm-12">
                        <FileUpload
                          defaultMessage="Drop files here to upload in bmp, gif, jpg, png, tif, doc, docx, xls, xlsx, msg or pdf format"
                          postUrl={ ApiService.getFileUploadUrl() }
                          accessTokenName={ ApiService.getAccessTokenName() }
                          acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx"
                          maxFilesize={ files.maxFilesize }
                          timeout={ files.uploadTimeout }
                          docCategory="supportingdocument"
                          docType={ supportingDocType != null ? supportingDocType : '' }
                          removeFileAfterUpload
                          onFileUploadCancel={ file => AddFormsPopupForm.onFileUploadCancel(file) }
                          onFileUploadSuccess={ (file, response) => this.onSupportingDocFileUploadSuccess(file, response) }
                          onFileUploadError={ (file, error) => AddFormsPopupForm.onFileUploadError(file, error) }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <div className="col-12">
                        <table className="table table-striped table-hover">
                          <thead>
                            <tr><th colSpan="2">Documents Uploaded</th></tr>
                          </thead>
                          <tbody>
                            { supportingDocs != null && supportingDocs.map(doc => doc != null && <tr key={ doc.id }>
                              <td className="col-11 uploaded-filename-td">{ `${ doc.fileName }` }</td>
                              <td className="col-1 text-right">
                                <button
                                  className="btn btn-sm btn-danger"
                                  type="button"
                                  title="Delete document"
                                  onClick={ () => this.onDeleteSupportingDocument(doc) }
                                >
                                  <span className="icon icon-delete" />
                                </button>
                              </td>
                            </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div> }
              { tabs != null && tabs[4] && tabs[4].enabled && <div id="tab-results" className={ `${ tabs[4].enabled && tabs[4].visible ? 'active' : '' }` }>
                <div className="results-container">
                  { !isSubmitting && formErrors === null && results == null && <p>
                    <strong>The form not been submitted.  Click &apos;Add&apos; to continue.</strong>
                  </p> }
                  { !isSubmitting && formErrors != null && formErrors.length > 0 && <div className="validation-container">
                    <h2><strong>Validation Errors</strong></h2>
                    <ul>
                      { formErrors != null && formErrors.map(error => error != null && <li key={ error.field }>{ error.message }</li>) }
                    </ul>
                  </div> }
                  { isSubmitting && <LoadingWrapper loaded={ !isSubmitting } /> }
                  { !isSubmitting && results != null && <div>
                    <h2><strong>Document upload results</strong></h2>
                    <p>
                      <strong className={ results.success ? 'is-success' : 'is-error' }>
                        Overall Result: { results.success ? 'Successful' : 'Failed' }
                      </strong><br /><span className={ results.success ? '' : 'is-error' }>Please review the documents uploaded below.</span>
                    </p>
                    { results.error != null && <p className="is-error"><strong>Error: </strong>{ results.error.message }</p>}
                    { (results.customerIds || (results.files != null && results.files.filter(f => f.customer != null).length > 0)) && <table className="table table-add-form-results table-striped table-hover mb">
                      <thead>
                        <tr>
                          <th className="col-5" colSpan="2">Temporary Customer ID(s) created</th>
                        </tr>
                      </thead>
                      <tbody>
                        { results.customerIds != null && results.customerIds.map(cust => cust != null && <tr key={ cust.id }>
                          <td colSpan="2">{ `${ cust.value }` }</td>
                        </tr>)}
                        { results.files != null && results.files.filter(f => f.customer != null).map(f2 => f2 != null && <tr key={ f2.id }>
                          <td colSpan="2">{ `${ f2.customer.value }` }</td>
                        </tr>)}
                      </tbody>
                    </table> }
                    { results.files != null && <table className="table table-add-form-results table-striped table-hover">
                      <thead>
                        <tr>
                          <th className="col-4 text-center">File Name</th>
                          <th className="col-4 text-center">File Type</th>
                          <th className="col-2 text-center">Upload Result</th>
                          <th className="col-2 text-center">View</th>
                        </tr>
                      </thead>
                      <tbody>
                        { results != null && results.files != null && results.files.map(doc => doc != null && doc.file && <tr key={ doc.file.id }>
                          <td className="col-4"><div className="dz-filename">{ `${ doc.file.fileName }` }</div></td>
                          <td className="col-4">{ (doc.file.category === 0 || doc.file.category === 2) ? `${ doc.file.typeDescription }` : '' }</td>
                          <td className="col-2 upload-result">
                            { doc.success && <i className="icon icon-3x icon-check" /> }
                            { !doc.success && <i className="icon icon-3x icon-cross" /> }
                            { doc.error && <span style={ { paddingleft: '2rem' } }>{ doc.error.message }</span> }
                          </td>
                          <td className="col-2 text-center">
                            { /* Category 0 is Form */ }
                            { doc.success && doc.file.category === 0 && <button
                              className="btn btn-sm"
                              onClick={ () => this.onTakeForm(doc.file.processedId) }
                              type="button"
                              title="Open"
                            >
                              <span className="icon icon-apps" />
                            </button> }
                          </td>
                        </tr>)}
                      </tbody>
                    </table> }
                  </div> }
                </div>
              </div> }
            </div>
          </div>
          <button
            type="button"
            id="dummy-add-form-btn"
            className="hide"
            onClick={ () => this.onFormSubmit() }
          >Add</button>
        </form>
      </div>
    );
  }
}

const UploadPdfReduxForm = reduxForm({
  form: 'uploadingPdfForm',
})(AddFormsPopupForm);

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = state => ({
  initialValues: {
    clientId: state.settings && state.settings.clients && state.settings.clients.length === 1 ? state.settings.clients[0].id : '',
  }
});

export const UploadPdfForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadPdfReduxForm);

export default UploadPdfForm;
